import classNames from 'classnames';
import { capitalize } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import RightArrowIcon from '../icons/RightArrowIcon.jsx';
import SubHeader from '../SubHeader.jsx';
import InitiativeParticipationsTable from './InitiativeParticipationsTable/index.jsx';

const InitiativesSection = ({ initiativeParticipations, type }) => {
  const [initiativesHidden, setInitiativesHidden] = useState(true);

  const toggleInitiatives = useCallback((e) => {
    e.preventDefault();
    setInitiativesHidden((hidden) => !hidden);
  }, []);

  const tableContainerId = `${type}InitiativesTableContainer`;
  const typeCapitalized = capitalize(type);

  const className = classNames('initiatives-section', {
    'initiatives-hidden': initiativesHidden,
  });

  useEffect(() => {
    setInitiativesHidden(!initiativeParticipations.length);
  }, [initiativeParticipations]);

  return (
    <section className={className}>
      <SubHeader flexJustify small>
        <div className="initiatives-heading">
          <h2>
            <a
              aria-controls={tableContainerId}
              aria-expanded={!initiativesHidden}
              className="flex"
              href="#"
              onClick={toggleInitiatives}
              role="button"
            >
              <RightArrowIcon className="collapse-caret" />
              <span className="initiative-type">{typeCapitalized}</span>
            </a>
          </h2>
          <strong className="bordered text-muted">
            Total:&nbsp;
            <span className="text-danger count">
              {initiativeParticipations.length}
            </span>
          </strong>
        </div>
      </SubHeader>
      <div id={tableContainerId}>
        {!initiativesHidden && (
          <InitiativeParticipationsTable
            initiativeParticipations={initiativeParticipations}
            initiativeType={type}
          />
        )}
      </div>
    </section>
  );
};

export default InitiativesSection;
